import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = { class: "bordered-card" }
const _hoisted_3 = { class: "card-body d-flex flex-column gap-4 sm-fs-xxs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "I.A.T.S.E. NATIONAL PENSION FUND", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " This Pension Credit History & Estimated Benefit Statement is based upon current Plan provisions and benefit levels and the service data in the Fund’s records at the time of your request. It is an estimate for your general information only. The information has not been verified and does not necessarily mean that you have a vested benefit. Your actual entitlement to benefits will, of course, depend upon the final components of the calculation, such as, for example, your years of service, age, marital status and the form in which you elect to receive your benefits when you are eligible to receive them. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " The Trustees reserve the right to correct any discrepancies in this estimate. Only the full Board of Trustees of the Plan has the authority to make a definite, official determination of your status and to approve or deny an application for benefits. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", null, "If you believe you are entitled to credit for work that is not reflected in the Fund’s records, it is your responsibility to provide documentation supporting that claim.")
], -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " If there is a discrepancy between the Rules and Regulations of the Plan, the Summary Plan Description and the information contained in this statement, the provisions contained in the Rules and Regulations of the Plan will govern. ", -1)
const _hoisted_10 = { class: "d-flex align-items-end justify-content-between gap-2" }
const _hoisted_11 = { class: "w-100 action-buttons sm-pdr-0 sm-pdl-0 justify-content-between mt-20" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 2,
  class: "plan-content"
}
const _hoisted_14 = { class: "bordered-card" }
const _hoisted_15 = { class: "card-body text-center" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "w-100 action-buttons sm-pdr-0 sm-pdl-0 justify-content-center mt-20" }
const _hoisted_18 = {
  key: 3,
  class: "plan-content"
}
const _hoisted_19 = { class: "plan-details" }
const _hoisted_20 = { class: "bordered-card overflow-visible" }
const _hoisted_21 = { class: "row d-flex align-items-center justify-content-between pdb-10 w-100" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", { class: "col-10 sm-fs-sm" }, " Payments and Contributions ", -1)
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-print" }, null, -1)
const _hoisted_25 = { class: "striped small equal-widths toggle no-underline" }
const _hoisted_26 = {
  key: 0,
  class: "tooltip-wrapper"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }, null, -1)
const _hoisted_28 = { class: "tooltip-text tooltip-text_secondary" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "vertical-top" }
const _hoisted_32 = {
  key: 0,
  class: "cell toggle-cell"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  class: "cell"
}
const _hoisted_36 = {
  key: 0,
  class: "view-details"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { colspan: "10" }
const _hoisted_39 = { class: "table-row_wrapper d-flex flex-column gap-20" }
const _hoisted_40 = {
  key: 0,
  class: "d-flex justify-content-between flex-wrap flex-md-nowrap gap-20"
}
const _hoisted_41 = { class: "cell-header hide-desktop" }
const _hoisted_42 = {
  key: 0,
  class: "cell-text w-100"
}
const _hoisted_43 = {
  key: 0,
  class: "tooltip-wrapper"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }, null, -1)
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "cell-text"
}
const _hoisted_47 = {
  key: 0,
  class: "subitems-columns"
}
const _hoisted_48 = { class: "d-flex subitems-columns_wrapper justify-content-between" }
const _hoisted_49 = { class: "cell-header hide-desktop" }
const _hoisted_50 = {
  key: 0,
  class: "cell-text"
}
const _hoisted_51 = {
  key: 1,
  class: "cell-text"
}
const _hoisted_52 = {
  key: 0,
  class: "divider-line m-10"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "divider-line black mt-10" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "divider-line black mb-10" }, null, -1)
const _hoisted_55 = { class: "d-flex justify-content-between gap-4 subitems-total text-dark fw-bold" }
const _hoisted_56 = { class: "cell-header hide-desktop" }
const _hoisted_57 = {
  key: 0,
  class: "w-100 cell-text"
}
const _hoisted_58 = {
  key: 0,
  class: "tooltip-wrapper"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }, null, -1)
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 1,
  class: "cell-text"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "11" }, " No data available")
], -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-10 w-100 sm-fs-xs" }, "F = Future Service Credits, P = Past Service Credits, M = Merged Credits", -1)
const _hoisted_66 = { class: "account-actions" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h4", null, " Related Links ", -1)
const _hoisted_68 = { class: "action-buttons sm-pdl-0 sm-pdr-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_ProfileInfo = _resolveComponent("ProfileInfo")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_ctx.showConditions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("span", null, [
                _createTextVNode(" This statement does not in any way modify the Rules and Regulations of the Plan, including but not limited to the rules concerning vesting and breaks in service. Your Summary Plan Description booklet contains a summary of the Rules and Regulations and should be referred to for a general description of Plan provisions including but not limited to how benefit credits are earned and the eligibility rules for receiving Pension benefits. Other important Plan features such as the Husband & Wife election/waiver, early retirement rules, etc. are also described therein. If you do not have a Plan booklet, you can obtain one by writing to the Pension Fund Office at the address below, by calling us at 1-800-456-FUND (3863), or by visiting our website at "),
                _createElementVNode("a", {
                  href: _ctx.baseUrl,
                  target: "_blank"
                }, "www.iatsenbf.org", 8, _hoisted_8),
                _createTextVNode(". ")
              ]),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CheckBox, {
              label: "By checking this box you are certifying that you have read, understood and agree to the conditions\n            listed herein.",
              className: "alert-checkbox text-large",
              modelValue: _ctx.agreement,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agreement) = $event)),
              id: "agree-pch"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: "",
              class: "btn btn-secondary plan-modal",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
            }, " Back "),
            _createElementVNode("button", {
              class: "btn btn-primary plan-modal",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)), ["prevent"])),
              disabled: !_ctx.agreement
            }, " Next ", 8, _hoisted_12)
          ])
        ]))
      : (_ctx.pensionStore.pchStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.pensionStore.pchStatus), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("a", {
                href: "",
                class: "btn btn-secondary plan-modal",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
              }, "Close")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_ProfileInfo, {
                title: "Total Credits",
                type: "pension",
                items: _ctx.firstCard,
                "has-divider": false,
                "use-container": true
              }, null, 8, ["items"]),
              _createVNode(_component_ProfileInfo, {
                title: "Key Dates",
                type: "pension",
                items: _ctx.secondCard,
                "has-divider": false,
                "use-container": true
              }, null, 8, ["items"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("button", {
                  class: "col-2 btn btn-secondary btn-sm",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlePrint && _ctx.handlePrint(...args))),
                  disabled: _ctx.printing
                }, [
                  _hoisted_24,
                  _createTextVNode(" " + _toDisplayString(_ctx.printing ? 'Printing...' : 'Print'), 1)
                ], 8, _hoisted_23)
              ]),
              _createElementVNode("table", _hoisted_25, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStore.history.headers, (header, key) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: key,
                        class: _normalizeClass({ 'pdl-40': key === 0 && _ctx.pensionStore.hasChildren})
                      }, [
                        _createTextVNode(_toDisplayString(header.title) + " ", 1),
                        (header.title === 'Comments')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("p", _hoisted_28, [
                                _createTextVNode(" For definitions of the terms ‘Break in Service,’ ‘Permanent Break in Service,’ ‘Uncredited,’ ‘Vested,’ and ‘Participation,’ please refer to the "),
                                _createElementVNode("a", {
                                  class: "text-white",
                                  href: `${_ctx.summaryPlanDescriptionLink}`,
                                  target: "_blank"
                                }, " Summary Plan Description (SPD). ", 8, _hoisted_29)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ]),
                (Object.entries(_ctx.pensionStore.history.rows).length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.pensionStore.history.rows).reverse(), ([year, data], mainKey) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: mainKey,
                          class: "parent-row sm-pdl-10 sm-pdr-10"
                        }, [
                          _createElementVNode("td", _hoisted_31, [
                            (data.Children)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                                  _createElementVNode("span", {
                                    class: "view-details",
                                    onClick: ($event: any) => (_ctx.toggleCell(mainKey))
                                  }, _toDisplayString(_ctx.toggleStates[mainKey] ? '-' : '+'), 9, _hoisted_33),
                                  _createElementVNode("span", {
                                    class: "text-underline",
                                    onClick: ($event: any) => (_ctx.openHistory(year))
                                  }, _toDisplayString(year), 9, _hoisted_34)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_35, [
                                  (_ctx.pensionStore.hasChildren)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    class: "text-underline",
                                    onClick: ($event: any) => (_ctx.openHistory(year))
                                  }, _toDisplayString(year), 9, _hoisted_37)
                                ]))
                          ]),
                          _createElementVNode("td", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              (!_ctx.toggleStates[mainKey])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.Parent, (item, key) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: key,
                                        class: "cell d-flex gap-2 w-sm-45 text-wrap"
                                      }, [
                                        _createElementVNode("p", _hoisted_41, _toDisplayString(key), 1),
                                        (Array.isArray(item))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (subItem, index) => {
                                                return (_openBlock(), _createElementBlock("p", {
                                                  key: index,
                                                  class: "w-100 d-flex justify-content-between"
                                                }, [
                                                  _createTextVNode(_toDisplayString(subItem.message) + " ", 1),
                                                  (subItem.instructions)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                                        _hoisted_44,
                                                        _createElementVNode("a", {
                                                          class: "tooltip-text tooltip-text_secondary",
                                                          href: "javascript:void(0)",
                                                          onClick: ($event: any) => (_ctx.openPDF(subItem.instructions))
                                                        }, " Summary Plan Description ", 8, _hoisted_45)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.formatItem(item)), 1))
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_Transition, { name: "slide-fade" }, {
                                default: _withCtx(() => [
                                  (_ctx.toggleStates[mainKey] && data.Children)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(data.Children), (child, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            _createElementVNode("div", _hoisted_48, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child, (childValue, childKey) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "d-flex cell flex-column gap-2",
                                                  key: childKey
                                                }, [
                                                  _createElementVNode("p", _hoisted_49, _toDisplayString(childKey), 1),
                                                  (Array.isArray(childValue))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.formatItem(childValue)), 1))
                                                ]))
                                              }), 128))
                                            ]),
                                            (index < data.Children.length - 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128)),
                                        _hoisted_53,
                                        _hoisted_54,
                                        _createElementVNode("div", _hoisted_55, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.Parent, (item, key) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: key,
                                              class: "cell d-flex gap-2"
                                            }, [
                                              _createElementVNode("p", _hoisted_56, _toDisplayString(key), 1),
                                              (Array.isArray(item))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (subItem, index) => {
                                                      return (_openBlock(), _createElementBlock("p", {
                                                        key: index,
                                                        class: "w-100 d-flex justify-content-between gap-10"
                                                      }, [
                                                        _createTextVNode(_toDisplayString(subItem.message) + " ", 1),
                                                        (subItem.instructions)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                                              _hoisted_59,
                                                              _createElementVNode("a", {
                                                                class: "tooltip-text tooltip-text_secondary",
                                                                href: "javascript:void(0)",
                                                                onClick: ($event: any) => (_ctx.openPDF(subItem.instructions))
                                                              }, " Summary Plan Description ", 8, _hoisted_60)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_ctx.formatItem(item)), 1))
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_62, _hoisted_64))
              ])
            ]),
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("button", {
                  class: "btn btn-secondary plan-modal",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal('add-beneficiary',
                    'My Beneficiary(ies)',
                    'plan-tables-striped beneficiary',
                    null,
                    null,
                    null,
                )))
                }, " Beneficiary(ies) "),
                (_ctx.isPensioner)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("button", {
                        class: "btn btn-tertiary btn-large plan-modal",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')))
                      }, " ACH/Check Destination"),
                      (_ctx.hasChecks)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-tertiary btn-large plan-modal",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal('check-replacement', 'Check Replacement', 'plan-form', 'pension')))
                          }, " Check Replacement "))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("a", {
                        href: "",
                        class: "btn btn-tertiary btn-large plan-modal",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Pension Application', 'plan-form', 'application')), ["prevent"]))
                      }, "Pension Application "),
                      _createElementVNode("a", {
                        href: "",
                        class: "btn btn-tertiary btn-large plan-modal",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Estimate Request', 'plan-form', 'estimate')), ["prevent"]))
                      }, " Estimate Request ")
                    ], 64)),
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Pension Forms & Documents', null, 'pension')), ["prevent"])),
                  class: "btn btn-tertiary btn-large plan-modal"
                }, "Forms & Documents ")
              ])
            ])
          ]))
}